var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.value ? '' : 'no-image'},[_c('img',{attrs:{"src":_vm.value ? _vm.value : '/assets/contact/avatar.png'}})])}
var staticRenderFns = []

export { render, staticRenderFns }